import { IMAGES } from "../data";

export const Logo = ({ className = "" }) => (
  <div className={`flex items-center gap-3 ${className}`} data-testid="brand-logo">
    <img src={IMAGES.ashutoshLogo} alt="Ashutosh Capital" className="h-11 w-auto object-contain mix-blend-multiply" />
    <span className="hidden sm:block h-6 w-px bg-ink/20" />
    <span className="hidden sm:block overline text-brand-green text-[10px] leading-none">Capital</span>
  </div>
);
